import React, { useEffect, useState } from "react";
import TextArea from "../../../../components/common/TextArea/TextArea";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ExclamtionMark from "./../../../../assets/images/icons/exclamation-mark.svg";
import InputNumberSmall from "../../../../components/common/InputText/InputNumbersSmall";
const AdatokItem = ({
  tabNo,
  activeTab,
  setActiveTab,
  destination,
  updateChanges,
}) => {
  const noteChangeHandler = (e) => {
    setNote(e.target.value);
  };

  const [emelet, setEmelet] = useState(
    destination?.emelet == null ? "" : destination?.emelet
  );
  const [tavolsag, setTavolsag] = useState(
    destination?.tavolsag == null ? "" : destination?.tavolsag
  );
  const [megallo, setMegallo] = useState(
    destination?.megallo == null ? "" : destination?.megallo
  );
  const [lift, setLift] = useState(destination?.lift);
  const [szuk_lepcsohaz, setSzukLepcsohaz] = useState(
    destination?.szuk_lepcsohaz
  );
  const [kozteruleti_ugyintezes, setKozteruletiUgyintezes] = useState(
    destination?.kozteruleti_ugyintezes
  );
  const [note, setNote] = useState(
    destination?.note == null ? "" : destination?.note
  );

  useEffect(() => {
    setEmelet(destination?.emelet == null ? "" : destination?.emelet);
    setTavolsag(destination?.tavolsag == null ? "" : destination?.tavolsag);
    setMegallo(destination?.megallo == null ? "" : destination?.megallo);
    setLift(destination?.lift == 0 ? false : true);
    setSzukLepcsohaz(destination?.szuk_lepcsohaz == 0 ? false : true);
    setKozteruletiUgyintezes(
      destination?.kozteruleti_ugyintezes == 0 ? false : true
    );
    setNote(destination?.note == null ? "" : destination?.note);
  }, [destination]);

  useEffect(() => {
    const place_id = destination?.place_id;
    const uniqueId = destination?.uniqueId;
    updateChanges(
      emelet,
      tavolsag,
      megallo,
      lift,
      szuk_lepcsohaz,
      kozteruleti_ugyintezes,
      note,
      place_id,
      uniqueId
    );
  }, [
    emelet,
    tavolsag,
    megallo,
    lift,
    szuk_lepcsohaz,
    kozteruleti_ugyintezes,
    note,
  ]);

  const onClick = () => {
    setActiveTab(tabNo);
  };
  return (
    <div className="w-1/3 p-1 min-w-[30rem]" onClick={onClick}>
      <div
        className={`flex flex-col gap-5 p-5 border-[1px] rounded-xl ${
          tabNo === activeTab
            ? "border-secondary-color  bg-[#0655671a]"
            : "bg-[#EAEBEA]"
        } font-lato text-primary-color`}
      >
        <h3 className="text-[2rem] font-bold  leading-normal ">
          {tabNo == 0 ? "Felpakolás" : `Lepakolás ${tabNo}.`}
        </h3>
        <p className="text-[1.125rem]  font-normal ">
          {destination?.cim}
          {/* Von-Werth-Straße 12 50670 Köln Deutschland */}
        </p>
        <div className="flex justify-between w-full">
          <div className="flex flex-col">
            <span className="font-bold text-[1.125rem] leading-normal">
              Emelet
            </span>
            <span className="font-normal text-[0.75rem] leading-normal">
              ab 2. Geschoss
            </span>
          </div>
          <InputNumberSmall
            value={emelet}
            onChange={(e) => setEmelet(e.target.value)}
          />
        </div>
        <div className="flex justify-between w-full">
          <div className="flex flex-col">
            <span className="font-bold text-[1.125rem] leading-normal">
              Távolság
            </span>
            <span className="font-normal text-[0.75rem] leading-normal">
              25 m+
            </span>
          </div>
          <InputNumberSmall
            value={tavolsag}
            onChange={(e) => setTavolsag(e.target.value)}
          />
        </div>
        <div className="flex justify-between w-full">
          <div className="flex flex-col">
            <span className="font-bold text-[1.125rem] leading-normal">
              Megálló
            </span>
            <span className="font-normal text-[0.75rem] leading-normal">
              50 km
            </span>
          </div>
          <InputNumberSmall
            value={megallo}
            onChange={(e) => setMegallo(e.target.value)}
          />
        </div>
        <div className="flex justify-between w-full">
          <div className="flex flex-row gap-3">
            <span className="font-bold text-[1.125rem] leading-normal">
              Lift
            </span>
            <img src={ExclamtionMark} className="w-6 cursor-pointer" />
          </div>
          <CheckBoxWithOutLabel
            value={"lift"}
            checked={lift}
            onClick={(e) => setLift(!lift)}
          />
        </div>
        <div className="flex justify-between w-full">
          <div className="flex flex-row gap-3">
            <span className="font-bold text-[1.125rem] leading-normal">
              Szűk lépcsőház
            </span>
            <img src={ExclamtionMark} className="w-6 cursor-pointer" />
          </div>
          <CheckBoxWithOutLabel
            value={"szuk_lepcsohaz"}
            checked={szuk_lepcsohaz}
            onClick={(e) => setSzukLepcsohaz(!szuk_lepcsohaz)}
          />
        </div>
        <div className="flex justify-between w-full">
          <div className="flex flex-row gap-3">
            <span className="font-bold text-[1.125rem] leading-normal">
              Közterületi ügyintézés
            </span>
            <img src={ExclamtionMark} className="w-6 cursor-pointer" />
          </div>
          <CheckBoxWithOutLabel
            value={"kozteruleti_ugyintezes"}
            checked={kozteruleti_ugyintezes}
            onClick={(e) => setKozteruletiUgyintezes(!kozteruleti_ugyintezes)}
          />
        </div>
        <TextArea
          placeholder="Kezd el gépeni a feljegyzést..."
          onChange={noteChangeHandler}
          value={note}
        />
      </div>
    </div>
  );
};

export default AdatokItem;
